import { Chip } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { WttpQuestionImportance } from 'src/graphql/generated/graphql';

export const ImportanceField = ({
  importance,
}: {
  importance: WttpQuestionImportance;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'wttp.question.list.columns',
  });
  const importanceColors: {
    [key in WttpQuestionImportance]:
      | 'default'
      | 'error'
      | 'info'
      | 'primary'
      | 'secondary'
      | 'success'
      | 'warning';
  } = {
    Low: 'default',
    Medium: 'info',
    High: 'error',
  };
  return (
    <Chip
      label={t(`importance-${importance.toLowerCase()}`)}
      color={importanceColors[importance]}
      size="small"
    />
  );
};
